<template>
	<BaseCard :is-editable="isEditable" :title="$t('photos').toString()" :is-toggleable="false" @clickEdit="edit">
		<div v-if="images.length > 0">
			<CoolLightBox :items="lightboxImages" :index="index" @close="index = null" />

			<div class="flex flex-wrap -m-1">
				<div v-for="(image, imageIndex) in images" :key="image.id ?? imageIndex" class="w-1/4 p-1 box-border">
					<img :src="image.base64content" :alt="'photo-' + imageIndex" class="photo-preview cursor-pointer" @click="index = imageIndex" />
				</div>
			</div>
		</div>

		<div v-else class="font-bold">
			{{ $t('no_images_transferred') }}
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';

export default {
	name: 'DamageAssessorCasePhotosCard',

	components: {
		BaseCard,
	},

	props: {
		damageAssessorCase: {
			type: Object,
			required: true,
		},

		isEditable: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			index: null,
		};
	},

	computed: {
		caseMedia() {
			return this.damageAssessorCase?.media ?? [];
		},
		brokerMedia() {
			return this.damageAssessorCase?.broker_case?.media ?? [];
		},
		images() {
			return [...this.caseMedia, ...this.brokerMedia].filter(item => item.category === null);
		},
		lightboxImages() {
			return this.images.map(item => item.base64content).filter(Boolean);
		},
	},

	methods: {
		edit() {
			this.$router.push({
				name: 'damageAssessorCaseEditPhotos',

				params: {
					id: this.damageAssessorCase.id,
				},
			});
		},
	},
};
</script>

<style scoped>
.photo-preview {
	width: 100%;
	height: 120px;
	object-fit: cover;
	object-position: center;
	border-radius: 0.25rem;
}
</style>
